import React from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import clsx from 'clsx';
import Tooltip from '@material-ui/core/Tooltip';

// import Chip from '@material-ui/core/Chip';
import { Input } from '@shared/components';
import InfoLightIcon from '@assets/icons/info-light.svg';

const AutoompleteComponent = ({
  chipProps = {},
  filterSelectedOptions = true,
  getOptionLabel = option => option.label,
  inputProps = {},
  label = '',
  onChange = () => {},
  classes = {},
  multiple = false,
  options = [],
  placeholder = '',
  tooltip = '',
  tooltipPlacement = 'top',
  variant = 'outlined',
  wrapperClassName = '',
  ...restProps
}) => (
  <div
    className={clsx(
      'd-flex',
      {
        'w-100': restProps.fullWidth,
      },
      wrapperClassName
    )}
    data-testid='autocomplete-wrapper'
  >
    <Autocomplete
      ChipProps={{
        color: 'primary',
        ...chipProps,
      }}
      filterSelectedOptions={filterSelectedOptions}
      getOptionLabel={getOptionLabel}
      multiple={multiple}
      classes={classes}
      options={options}
      onChange={onChange}
      renderInput={params => (
        <Input
          data-testid='autocomplete-input'
          {...inputProps}
          {...params}
          label={label}
          placeholder={placeholder}
        />
      )}
      variant={variant}
      {...restProps}
      data-testid='autocomplete-search'
    />
    {tooltip && (
      <Tooltip
        className='ml-2'
        title={tooltip}
        placement={tooltipPlacement}
        data-testid='autocomplete-tooltip'
      >
        <img src={InfoLightIcon} alt='field tooltip' className='info-icon' />
      </Tooltip>
    )}
  </div>
);

export default AutoompleteComponent;
